import { Box, IconButton, Paper, useTheme } from '@mui/material';
import { FC, ReactNode, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';


interface SidebarLayoutProps {
  children?: ReactNode;
}

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const theme = useTheme();
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);

  return (
		<Paper>
			<Sidebar />
			<Box
				sx={{
					position: 'relative',
					zIndex: 5,
					display: 'block',
					flex: 1,
					[theme.breakpoints.up('lg')]: {
						ml: `${theme.sidebar.width}`,
					},
				}}>
				<Box
					component="span"
					sx={{
						ml: 2,
						display: { lg: 'none', xs: 'inline-block' },
					}}>
					<IconButton color="primary" onClick={toggleSidebar}>
						{!sidebarToggle ? <MenuTwoToneIcon fontSize="small" /> : <CloseTwoToneIcon fontSize="small" />}
					</IconButton>
				</Box>
				<Box display="block">
					<Outlet />
				</Box>
			</Box>
		</Paper>
	)
};

export default SidebarLayout;
